import { TelegramIcon, FindItemIcon, InfoIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { Header } from "../../../components/header/header";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { TextInput } from "../../../components/textInput/textInput";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import KnowledgeAPI from "../../../api/KnowledgeAPI";
import { Text } from "../../../components/text/text";

import styles from "./knowledgeBaseTestsPage.module.css";
import { Test } from "./KnowledgeTest";

export const KnowledgeBaseTestsPage = () => {
    const openPage = useOpenPage();
    const [search, setSearch] = useState("");
    const [materialName, setMaterialName] = useState("");
    const [tests, setTests] = useState([]);
    const [materials, setMaterials] = useState([]);
    const { categoryId } = useParams();

    useEffect(() => {
        if (!categoryId) return;
        KnowledgeAPI
            .fetchMaterialTests(categoryId)
            .then(res => {
                setTests(res.tests);
                setMaterialName(res.name);
            })
            .catch(console.error);

        KnowledgeAPI
            .fetchEmployeeEducationMaterials(categoryId)
            .then(setMaterials)
            .catch(console.error);
    }, [categoryId])

    const filteredMaterials = useMemo(() => materials.filter(test => test.title.toLowerCase().includes(search.trim().toLowerCase())), [materials, search]);
    const filteredTests = useMemo(() => tests.filter(test => test.name.toLowerCase().includes(search.trim().toLowerCase())), [tests, search]);

    return (
        <>
            <Header />

            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />
            <Button onClick={openPage("experts")} text="Спроси эксперта" icon={<TelegramIcon />} />

            <Text as="h1" variant="h2" className={styles.tests_title}>{materialName}</Text>

            {
                filteredMaterials.length > 0 &&
                <>
                    <Text as="div" variant="h3" className={styles.block_subtitle}>Материалы</Text>
                    <div className={styles.materials_container}>
                        {
                            filteredMaterials.map(data =>
                                <div className={styles.material} key={data.id} onClick={openPage(`/knowledge/${categoryId}/materials/${data.id}`)}>
                                    <Text as="div" variant="captionStrong" className={styles.material_title} clamp={10}>
                                        {data.title}
                                    </Text>
                                    <InfoIcon width="125px" height="125px" className={styles.material_icon} />
                                </div>
                            )
                        }
                    </div>
                </>
            }

            {
                filteredTests.length > 0 &&
                <>
                    <Text as="div" variant="h3" className={styles.block_subtitle}>Тесты</Text>
                    <div className={styles.tests_container}>
                        {
                            filteredTests.map((test) =>
                                <Test
                                    key={test.id}
                                    materialId={categoryId}
                                    data={test}
                                />
                            )
                        }
                    </div>
                </>
            }
        </>
    )
}
